import { santiImgs } from "./CabañasImg";
import { facuImgs } from "./CabañasImg";
import { gonzaImgs } from "./CabañasImg";
import { almiImgs } from "./CabañasImg";


const featuresAB = [
  "Capacidad para 7 personas",
  "2 Dormitorios",
  "Aire Acondicionado frío/calor",
  "2 baños",
];

const featuresGO = [
  "Capacidad para 5 personas",
  "1 Dormitorio",
  "Aire Acondicionado frío/calor",
  "2 baños",
];

const cabañasData = [
  {
    id: 1,
    name: "Cabaña Santi",
    description: "Dos plantas pensadas para grupos que quieren espacio y comodidad. En planta baja encontrás la cocina-comedor equipada con dos camas individuales, y arriba dos dormitorios — uno con tres camas y otro matrimonial con aire acondicionado. Ideal para familias o amigos que vienen a desconectar.",
    features: featuresAB,
    capacity: 7,
    photos: santiImgs,
  },
  {
    id: 2,
    name: "Cabaña Facu",
    description: "Igual de completa que su gemela, con la misma distribución en dos plantas y todos los detalles para que no te falte nada. Perfecta para grupos de hasta 7 que buscan comodidad, privacidad y ese ambiente serrano que invita a quedarse.",
    features: featuresAB,
    capacity: 7,
    photos: facuImgs,
  },
  {
    id: 3,
    name: "Cabaña Gonza",
    description: "Ideal para una familia chica o una pareja con amigos. Tiene todo lo necesario en una planta bien aprovechada — dormitorio matrimonial con aire acondicionado, una cama individual extra y cocina-comedor equipada para disfrutar sin apuros.",
    features: featuresGO,
    capacity: 5,
    photos: gonzaImgs,
  },
  {
    id: 4,
    name: "Cabaña Almi",
    description: "Acogedora y con el mismo espíritu que su gemela, pensada para quienes quieren tranquilidad sin renunciar a la comodidad. Con lugar para hasta 5 personas, es el rincón perfecto para escaparse unos días a las sierras.",
    features: featuresGO,
    capacity: 5,
    photos: almiImgs,
  },
];

export default cabañasData;